import { Fragment } from 'react';

/**
 * Wraps case-insensitive matches of `query` in `<mark>`; renders `text` verbatim when `query`
 * is empty (the common case — most artifact text isn't under an active search).
 */
export function Highlight({ text, query }: { text: string; query: string }): JSX.Element {
  const q = query.trim();
  if (!q) return <>{text}</>;

  const lower = text.toLowerCase();
  const needle = q.toLowerCase();
  const parts: JSX.Element[] = [];
  let i = 0;
  let idx = lower.indexOf(needle, i);
  let key = 0;
  while (idx !== -1) {
    if (idx > i) parts.push(<Fragment key={key++}>{text.slice(i, idx)}</Fragment>);
    parts.push(<mark key={key++}>{text.slice(idx, idx + needle.length)}</mark>);
    i = idx + needle.length;
    idx = lower.indexOf(needle, i);
  }
  if (i < text.length) parts.push(<Fragment key={key++}>{text.slice(i)}</Fragment>);
  return <>{parts}</>;
}
